function WalletOwnerManagement() {
  let walletOwnerManagement = [
    {
      name: "Owner Management",
      icon: "account-management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "walletOwnerManagement",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/walletOwnerManagement",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  const createWalletOwner = () => {
    const mybanksArr = [
      {
        path: "/index/create-wallet-owner",
        name: "Create Owner",
        icon: "create-wallet",
        logoName: "CREATE OWNER",
        flag:"CREATE OWNER"
        // flag: "isMyBankAllowed",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mybanksArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  const walletOwnerSettings = () => {
    const mywalletsArr = [
      {
        path: "/index/wallet-owner-settings",
        name: "Owner Settings",
        icon: "manual-upgrade-request",
        logoName: "OWNER SETTINGS",
        flag:"OWNER SETTINGS"
        // flag: "isMyWalletAllowed",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mywalletsArr[0].flag])
    // ) {
    return mywalletsArr;
    // } else {
    //   return "";
    // }
  };

  const roleManagement = () => {
    const mywalletsArr = [
      {
        path: "/index/role-management",
        name: "Role Mnt",
        icon: "manual-upgrade-request",
        logoName: "ROLE MANAGEMENT",
        flag:"ROLE MNT"
        // flag: "isMyWalletAllowed",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mywalletsArr[0].flag])
    // ) {
    return mywalletsArr;
    // } else {
    //   return "";
    // }
  };

  const entityTypeManagement = () => {
    const mycardsArr = [
      {
        path: "/index/entity-type-management",
        name: "Entity Type Mnt",
        icon: "manual-otp-request",
        logoName: "MyAccounts",
        flag:"ENTITY TYPE MNT"
        // MyCards
        // flag: "isMyCardAllowed",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  const businessNatureManagement = () => {
    const profileArr = [
      {
        path: "/index/business-nature-management",
        // path: "/index/business-nature-management1",
        name: "Business Nature Mnt",
        icon: "customer-master",
        logoName: "BUSINESS NATURE MANAGEMENT",
        flag:"BUSINESS NATURE MNT"
        // flag: "isProfileSetting",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const businessNatureSubCategory = () => {
    const businessSubCategoryArr = [
      {
        path: "/index/AdminBusinessNatureSubCategory",
        // path: "/index/business-nature-management1",
        name: "Business Nature Sub-Category",
        icon: "customer-master",
        logoName: "BUSINESS NATURE MANAGEMENT",
        flag:"BUSINESS NATURE SUB-CATEGORY"
        // flag: "isProfileSetting",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return businessSubCategoryArr;
    // } else {
    //   return "";
    // }
  };

  const ibanProviderManagement = () => {
    const ibanArr = [
      {
        path: "/index/AdminIBNProviderManagement",
        // path: "/index/business-nature-management1",
        name: "IBAN Provider Management",
        icon: "customer-master",
        logoName: "MyBank",
        flag:"BUSINESS NATURE SUB-CATEGORY"
        // flag: "isProfileSetting",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return ibanArr;
    // } else {
    //   return "";
    // }
  };

  let a = dashboard();
  let b = createWalletOwner();
  let c = walletOwnerSettings();
  let d = roleManagement();
  let e = entityTypeManagement();
  let f = businessNatureManagement();
  let g = businessNatureSubCategory();
  let h = ibanProviderManagement();
  walletOwnerManagement[0].items = [...a, ...b, ...c, ...d, ...e, ...f, ...g, ...h];

  return walletOwnerManagement;
}

export default WalletOwnerManagement;
